<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="实时数据"
      edit-title
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
   
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
    
      @create-opened="createOpened"
    
    >
      <template slot="form">
      
       
           <el-row>
            <el-col :span="12">
              <el-form-item label="温度1" prop="T1">
                 {{data.T1}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="温度2" prop="T2">
                 {{data.T2}}
              </el-form-item>
            </el-col>
             <el-col :span="12">
              <el-form-item label="温度3" prop="T3">
                 {{data.T3}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="温度4" prop="T4">
                 {{data.T4}}
              </el-form-item>
            </el-col>
              <el-col :span="12">
              <el-form-item label="温度5" prop="T5">
                 {{data.T5}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="温度6" prop="T6">
                 {{data.T6}}
              </el-form-item>
            </el-col>
            

             <el-col :span="12">
              <el-form-item label="温度7" prop="T7">
                 {{data.T7}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="温度8" prop="T8">
                 {{data.T8}}
              </el-form-item>
            </el-col>
              <el-col :span="12">
              <el-form-item label="温度9" prop="T9">
                 {{data.T9}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="温度10" prop="T10">
                 {{data.T10}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="油温" prop="OT">
                 {{data.OT}}
              </el-form-item>
            </el-col>   
           </el-row>
      
       
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";


export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
 
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
     
      api: require('@/api/equipment/realtimedata').default,
      data: {
        T1: null,
        T2: null,
        T3: null,
        T4: null,
        T5: null,
        T6: null,
        T7: null,
        T8: null,
        T9: null,
        T10: null,
        OT: null,
      },
    
   
    };
  },
  methods: {
                   
  },
};
</script>
